import { render, staticRenderFns } from "./RegisterAnnualSuccess.vue?vue&type=template&id=3f11c68b&"
import script from "./RegisterAnnualSuccess.vue?vue&type=script&lang=js&"
export * from "./RegisterAnnualSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports